import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { updateShowUserProfileModal, updateShowOtherUserProfileModal } from '../../../../actions/modal';
import { getUserBasicProfile, saveUserProfileAsync } from '../../../../actions/user.js';

const UserProfileRightTopPanel = (props) => {
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.usersReducer.userProfile);
  const savingUserProfile = useSelector((state) => state.usersReducer.savingUserProfile);
  const timezones = useSelector((state) => state.usersReducer.timezones);

  const saveProfile = () => {
    let areThereErrors = forceValidation(undefined, undefined, 'profileSaveChanges');
    if (!areThereErrors) {
      console.info('----xin---- ready to save profile');
      props.onSave();
    }
  };
  const cancelProfile = () => {
    // resetForm();
    dispatch(getUserBasicProfile());
    dispatch(updateShowUserProfileModal(false));
  };

  const closeOtherUsersProfile = () => {
    dispatch(updateShowOtherUserProfileModal(false));
  };

  return (
    <div>
      {props.updateOrView && props.updateOrView == 'view' ? (
        <div className="ui actions mrbl">
          <button
            tabIndex="2"
            type="button"
            onClick={closeOtherUsersProfile}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtsss"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      ) : (
        <div className="ui actions mrbl">
          <button
            data-group="profileSaveChanges"
            type="button"
            className={
              'ui cancel   left-text labeled icon button color-good-things color-good-things-hover color-white  max-width mrlnull mrbm' +
              (savingUserProfile ? ' loading ' : ' ') +
              (timezones && timezones.length > 0 ? ' ' : ' disabled ')
            }
            onClick={saveProfile}
          >
            <i className="checkmark  icon" />
            {APP.LANGUAGE.UserProfile.SaveChanges}
          </button>
          <button
            tabIndex="2"
            type="button"
            onClick={cancelProfile}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtsss"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfileRightTopPanel;
